import { AnalyticsProvider } from '../interfaces/EventInterfaces'
import { initializeAnalyticsProviders } from '../index'

class AnalyticsProviderFactory {
  private providers: { [key: string]: AnalyticsProvider } = {};

  registerProvider(name: string, provider: AnalyticsProvider): void {
    this.providers[name] = provider;
  }

  getProvider(name: string): AnalyticsProvider {
    // Ensure providers are initialized
    initializeAnalyticsProviders();

    const provider = this.providers[name];
    if (!provider) {
      throw new Error(`Provider ${name} not registered`);
    }
    return provider;
  }
}

export default new AnalyticsProviderFactory();